<template>
	<div>
		<div id="loading" v-if="loading">
			<div class="load-circle" style="text-align: center">
				<div style="text-align: center">
					<img src="/img/logo.png" style="text-align: center" class="img-fluid" />
				</div>
				<div style="">
					<span class="loader"></span>
					<span class="loader"></span>
					<span class="loader"></span>
				</div>
			</div>
		</div>
		<div class="header">
			<nav class="navbar">
				<a class="navbar-brand" href="/">
					<img :src="empresa.logo" alt="" />
					<div class="float-logo">
						<span>{{ empresa.razon_social }}</span
						><br />
						<!--
						<span>CONSEJO DEPARTAMENTAL DE SAN MARTÍN</span>
						-->
					</div>
				</a>
				<div class="menubar" @click="toggleMenu" style="display: none">
					<i class="fa fa-bars"></i>
				</div>
				<ul class="navbar-nav" :class="{ active: isMenuVisible }">
					<li class="nav-item" :class="[($route.name=='/')?'nav-active':'']">
						<a class="nav-link" :href="'/'">Inicio</a>
					</li>
					<li class="nav-item" :class="[($route.name=='tramites')?'nav-active':'']">
						<a class="nav-link" href="/tramites">Trámites</a>
					</li>
					<li class="nav-item" :class="[($route.name=='servicios')?'nav-active':'']">
						<a class="nav-link" href="/servicios">Servicios</a>
					</li>
					<li class="nav-item menu-item" @click="showSubmenu" :class="[($route.name=='nosotros') ||  ($route.name=='documentos_normativos') ?'nav-active':'']">
						<p class="nav-link m-0">Institucional <i class="fa fa-angle-down ml-2"></i></p>
						<ul v-show="submenuVisible" class="submenu border">
							<li class="nav-item">
								<a class="nav-link" href="/nosotros">Sobre nosotros</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" href="/documentos_normativos">Documentos normativos</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" href="/galeria">Eventos institucionales</a>
							</li>
						</ul>
					</li>
					<li class="nav-item" :class="[($route.name=='noticias')?'nav-active':'']">
						<a class="nav-link" href="/noticias">Noticias</a>
					</li>
					<li class="nav-item intranet">
						<a class="nav-link" href="https://intranet.cmvsanmartin.org.pe/" target="_blank">Acceso Colegiado <i class="fa fa-user ml-2"></i></a>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
	data() {
		return {
			submenuVisible: false,
			imageVisible: false,
			selectedImage: '',
			showScrollTop: false,
			isMenuVisible: false
		}
	},
	name: 'ToolBar',
	computed: {
		...mapState(['loading', 'empresa'])
	},
	methods: {
		...mapMutations(['setLoading']),
		...mapActions(['loadObjEmpresa']),
		// Submenú
		showSubmenu() {
			this.submenuVisible = !this.submenuVisible
		},
		// Menú responsive
		toggleMenu() {
			this.isMenuVisible = !this.isMenuVisible
		}
	},
	mounted() {
		this.loadObjEmpresa()
	}
}
</script>
<style>
.active {
	display: block !important;
}
</style>
